import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import store, { WAREHOUSE_TYPE } from '../store';

function WarehouseForm({ value, locations, role }) {
	const values = useMemo(() => {
		const out = {};
		Object.values(locations).forEach(key => {
			out[key] = true;
		});
		const locs = Object.keys(out).map(label => ({ value: label, label }));
		if(locs.length && role === 'CUSTOMER_SERVICE') {
			locs.unshift({ value: '', label: 'Alle' });
		}
		return locs;
	}, [locations, role]);
	useEffect(() => {
		if(values.length && !values.some(v => v.value === value)) {
			store.dispatch({
				type: WAREHOUSE_TYPE,
				payload: values[0].value
			});
		}
	}, [values, value]);
	if(!values.length) {
		return null;
	}
	return <select className="form-control w-auto d-inline-block mr-1" onChange={e => {
		const wh = values.find(w => w.value === e.target.value) ?? values[0];
		store.dispatch({
			type: WAREHOUSE_TYPE,
			payload: wh.value
		});
	}} value={value}>
		{values.map(w => <option value={w.value} key={w.value}>{w.label}</option>)}
	</select>;
}

export function inWarehouse(warehouse, line, locations) {
	if(!warehouse) {
		return true;
	} else if(!line.location) {
		return false;
	}
	return locations[line.location] === warehouse;
}

export default connect(({ warehouse, locations, person }) => {
	return { value: warehouse, locations, role: person.role };
})(WarehouseForm);
